import { createFileRoute, Link, Outlet, stripSearchParams } from "@tanstack/react-router";
import { getLesdag, isoWeekday, parseDateParam } from "#/modules/les.planning/domain/calendar";
import { RoosterRouteDialog, roosterRouteOptions } from "#/modules/les.planning/rooster-route";
import { ROOSTER_SEARCH_DEFAULTS, roosterSearchSchema } from "#/modules/les.planning/schema.search";
import { PlanningProvider, useUndo } from "#/modules/les.planning/services/runtime";

export const Route = createFileRoute(
  "/$locale/{-$schoolyear}/_authenticated/$school/lessons/today/rooster",
)({
  ...roosterRouteOptions,
  validateSearch: roosterSearchSchema,
  search: { middlewares: [stripSearchParams(ROOSTER_SEARCH_DEFAULTS)] },
  component: RoosterPage,
});

function RoosterPage() {
  const { school, schoolyear } = Route.useParams();
  // The lesdag has no planning runtime of its own, unlike the lesweek.
  return (
    <PlanningProvider tenant={{ school, schoolyear }}>
      <Rooster />
    </PlanningProvider>
  );
}

function Rooster() {
  const params = Route.useParams();
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  useUndo();
  return (
    <RoosterRouteDialog
      params={params}
      // It opens on the weekdag of the day that shows.
      weekdag={search.weekdag ?? isoWeekday(getLesdag(parseDateParam(search.date)))}
      onWeekdagChange={(weekdag) =>
        void navigate({ search: (prev) => ({ ...prev, weekdag }), replace: true })
      }
      weekoverzicht={
        <Link
          to="/$locale/{-$schoolyear}/$school/lessons/today/rooster/week"
          params={params}
          search={true}
        />
      }
      vakanties={
        <Link
          to="/$locale/{-$schoolyear}/$school/lessons/today/rooster/vakanties"
          params={params}
          search={true}
        />
      }
      onClose={() =>
        void navigate({
          to: "..",
          search: ({ date, docenten }) => ({ date, docenten }),
          replace: true,
          resetScroll: false,
          viewTransition: true,
        })
      }
    >
      <Outlet />
    </RoosterRouteDialog>
  );
}
